module.exports = __webpack_public_path__ + "media/reskin-images/img--access-teams-b0d1ae20.jpg";